module.exports = __webpack_public_path__ + "static/media/sound_7.bb79bac7.mp3";